const formatPhoneNumber = (phoneNumber: string): string => {
  const match = phoneNumber.match(/\+1 (\d{3})-(\d{3})-(\d{4})/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber; // Return the original if the format does not match
};

export default formatPhoneNumber